var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLottery && _vm.$can('events.lottery'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block",attrs:{"disabled":_vm.insufficientTickets},on:{"click":function($event){return _vm.handleRunLottery()}}},[_vm._v("\n  Realizar Sorteio\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08381c76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Events/Actions/BtnRunLottery.vue
// module id = cl5G
// module chunks = 10